/*=============================================== ListGroupPage ===============================================*/

import { ListGroup } from "tsx-library-julseb"
import type { ListGroupItemProps } from "tsx-library-julseb/types"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import { commonProps } from "data"

const ListGroupPage = () => {
    const listItems: ListGroupItemProps[] = [
        {
            text: "Item",
        },
        {
            text: "Text",
            subtext: "Subtext",
        },
        {
            text: "Item",
            badge: { number: 350, color: "danger" },
        },
        {
            text: "Item",
            badge: { icon: "star", color: "success" },
        },
        {
            text: "Item",
            badge: { color: "warning" },
        },
        {
            text: "Router link",
            date: "2022-09-07",
            subtext: "Subtext",
            to: "/",
            blank: true,
        },
        {
            text: "Item with href",
            date: "2022-09-07",
            subtext: "Subtext",
            href: "#",
        },
        {
            text: "Item with onClick",
            date: "2022-09-07",
            subtext: "Subtext",
            onClick: () => console.log("Clicked!"),
        },
        {
            text: "Item disabled",
            date: "2022-09-07",
            onClick: () => console.log("Clicked!"),
            disabled: true,
        },
    ]

    const items: ItemType[] = [
        {
            content: <ListGroup items={listItems} showNumbers />,
            code: 'const listItems = [\n    {\n        text: "Item",\n    },\n    {\n        text: "Text",\n        subtext: "Subtext",\n    },\n    {\n        text: "Item",\n        badge: { number: 350 },\n        badgeColor: "danger",\n    },\n    {\n        text: "Item",\n        badge: { icon: "star" },\n        badgeColor: "success",\n    },\n    {\n        text: "Item",\n        badge: true,\n        badgeColor: "warning",\n    },\n    {\n        text: "Router link",\n        date: "2022-09-07",\n        subtext: "Subtext",\n        to: "/",\n        blank: true,\n    },\n    {\n        text: "Item with href",\n        date: "2022-09-07",\n        subtext: "Subtext",\n        href: "#",\n    },\n    {\n        text: "Item with onClick",\n        date: "2022-09-07",\n        subtext: "Subtext",\n        onClick: () => console.log("Clicked!"),\n    },\n    {\n        text: "Item disabled",\n        date: "2022-09-07",\n        onClick: () => console.log("Clicked!"),\n        disabled: true,\n    },\n]\n\n<ListGroup items={listItems} showNumbers />',
            codeTs: 'const listItems: ListGroupItemProps[] = [\n    {\n        text: "Item",\n    },\n    {\n        text: "Text",\n        subtext: "Subtext",\n    },\n    {\n        text: "Item",\n        badge: { number: 350 },\n        badgeColor: "danger",\n    },\n    {\n        text: "Item",\n        badge: { icon: "star" },\n        badgeColor: "success",\n    },\n    {\n        text: "Item",\n        badge: true,\n        badgeColor: "warning",\n    },\n    {\n        text: "Router link",\n        date: "2022-09-07",\n        subtext: "Subtext",\n        to: "/",\n        blank: true,\n    },\n    {\n        text: "Item with href",\n        date: "2022-09-07",\n        subtext: "Subtext",\n        href: "#",\n    },\n    {\n        text: "Item with onClick",\n        date: "2022-09-07",\n        subtext: "Subtext",\n        onClick: () => console.log("Clicked!"),\n    },\n    {\n        text: "Item disabled",\n        date: "2022-09-07",\n        onClick: () => console.log("Clicked!"),\n        disabled: true,\n    },\n]\n\n<ListGroup items={listItems} showNumbers />',
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "showNumbers",
            type: "boolean",
        },
        "separator",
        {
            subtitle: "items",
            type: "array of objects",
            required: true,
        },
        {
            title: (
                <>
                    <code>item</code> object
                </>
            ),
            subtitle: "text",
            type: "string",
            required: true,
        },
        {
            subtitle: "subtext",
            type: "string",
        },
        {
            subtitle: "date",
            intro: (
                <>
                    Only if <code>badge</code> is not defined.
                </>
            ),
            type: "string or Date",
        },
        "separator-small",
        {
            subtitle: "badge",
            type: "boolean or object",
        },
        {
            title: (
                <>
                    <code>badge</code> object
                </>
            ),
            subtitle: "icon",
            intro: commonProps.addIconCapital,
            type: "string",
        },
        {
            subtitle: "number",
            intro: (
                <>
                    Only if <code>icon</code> is not defined.
                </>
            ),
            type: "number",
        },
        {
            subtitle: "color",
            type: "string",
            possible: commonProps.colorsShort,
            possibleString: <></>,
            default: "",
            required: true,
        },
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default ListGroupPage
